import { cfgHasSports, toTileCdn } from '@infinitro/config';
export const sports = cfgHasSports()
    ? [
        {
            game: 'soccer-1',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/soccer`)
        },
        {
            game: 'basketball-2',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/basketball`)
        },
        {
            game: 'baseball-3',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/baseball`)
        },
        {
            game: 'ice-hockey-4',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/ice_hockey`)
        },
        {
            game: 'mixed-martial-arts-117',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/mma`)
        },
        {
            game: 'tennis-5',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/tennis`)
        },
        {
            game: 'american-football-16',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/american_football`)
        },
        {
            game: 'boxing-10',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/boxing`)
        },
        {
            game: 'table-tennis-20',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/table_tennis`)
        },
        {
            game: 'volleyball-23',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/volleyball`)
        },
        {
            game: 'formula-1-40',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/f1`)
        },
        {
            game: 'darts-22',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/darts`)
        },
        {
            game: 'cricket-21',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/cricket`)
        },
        {
            game: 'golf-9',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/golf`)
        },
        {
            game: 'snooker-19',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/snooker`)
        },
        {
            game: 'chess-33',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/chess`)
        },
        {
            game: 'rally-404',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/rally`)
        },
        {
            game: 'speedway-404',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/speedway`)
        },
        {
            game: 'field-hockey-24',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/hockey`)
        },
        {
            game: 'alpine-skiing-43',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/alpine_skiing`)
        },
        {
            game: 'ski-jumping-48',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/ski_jumping`)
        },
        {
            game: 'badminton-31',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/badminton`)
        },
        {
            game: 'kabaddi-138',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/kabaddi`)
        },
        {
            game: 'gaelic-hurling-404',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/gaelic_hurling`)
        },
        {
            game: 'biathlon',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/biathlon`)
        },
        {
            game: 'futsal-29',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/futsal`)
        },
        {
            game: 'floorball-7',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/floorball`)
        },
        {
            game: 'cross-country-46',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/cross_country`)
        },
        {
            game: 'waterpolo-26',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/waterpolo`)
        },
        {
            game: 'stock-car-racing-404',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/stock_car_racing`)
        },
        {
            game: 'cycling-17',
            prov: 'Sports',
            tile: toTileCdn(`t/sports/cycling`)
        }
    ]
    : [];
